import { withMetadata } from '../min/metadata'

import _format from '../es6/format'

export function format() {
	return withMetadata(_format, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/format.js
// module id = 640
// module chunks = 0